declare const wenji: IWenji;

// Angular
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

// Afidium
import { IWenji } from 'libraries/interfaces/IWenji';
import { IValidity } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { IMomentDateFormat } from 'libraries/interfaces/IMomentDateFormat';

//libs
import { faCheck, faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export interface IDateValidity {
    dates: IValidity;
    valid: boolean;
}

@Component({
    selector: 'date-validity',
    template: `
        <fa-icon 
                [icon]="validity.valid ? iconCheck : iconTimes"
                [class.fa-check]="validity.valid"
                [class.fa-times]="!validity.valid">
        </fa-icon>
        <span>{{
            validity.valid ?
            labels.valid :
            labels.expired
        }} {{ validity.dates.end | dateMoment: dateFormat.momentShort }}</span>
    `,
    styles: [`
        .fa-times {
            color: #a94442;
        }

        .fa-check {
            color: #3c763d;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateValidityComponent {
    @Input()
    public validity: IDateValidity;

    public iconCheck: IconDefinition = faCheck;
    public iconTimes: IconDefinition = faTimes;

    public labels: ILabels = {
        valid: Yii.t('wui-shared-js', "Valide jusqu'au "),
        expired: Yii.t('wui-shared-js', "Expiré depuis le ")
    };

    public dateFormat: IMomentDateFormat = JSON.parse(wenji.ui.dateFormat);
}